/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class BenefitsTabDirective {
    public restrict = 'E';
    public scope = {};
    public template;
    public value;
    public isOpen: boolean = true;
    constructor() {
        this.restrict = 'E';
        this.scope = true;
        this.template = `
                        <div id="b_benefits" ng-if="!C.benefit" class="tab-pane">
                        <div class="panel">
                            <div class="float-right p-r-30">
                                <md-button ng-click="C.add_benefit()" ng-if="C.hasPermission('org.change_org')"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">add_circle</md-icon>
                                    <md-tooltip md-direction="bottom">Create a new beneficiary.</md-tooltip>
                                </md-button>
                            </div>
                            <br>
                            <br>
                            <div ng-repeat="data in C.org.extra.benefits track by $index">
                            <div id="{{ariaId}}" class="card-header" data-toggle="collapse" data-target="#benefit{{$index}}" 
                                    aria-expanded="false" aria-controls="#{{collapseId}}" ng-click="C.navigateBenefits(data, &quot;benefit&quot;, $index);">
                                <h6>
                                    <div class="row">
                                        <div style="float: right; padding-right: 20px;">
                                            <md-icon class="drop-arrow" style="margin-bottom: -10px;" md-font-library="material-icons">keyboard_arrow_down</md-icon>
                                        </div>
                                        <div class="accordian-card-title" style="margin-top: 10px;">
                                            <h5>{{data.name}}</h5> 
                                            <p>({{data.description}})
                                            <a  ng-if="!C.editing_new &amp;&amp; C.hasPermission(&quot;org.change_org&quot;)"
                                                ng-click="C.delete_modal(&quot;benefit&quot;, data)" class="md-warn">
                                                <md-tooltip md-direction="bottom">Permanently delete this benefit.</md-tooltip>
                                                <i class="material-icons">delete_forever</i>
                                            </a></p>
                                        </div>
                                    </div>
                                </h6>
                            </div>
                            <div id="benefit{{$index}}" class="collapse" aria-labelledby="{{ariaId}}">
                                <br>
                                <form class="form-group" style="padding: 0 50px 0 50px;">
                                    <div class="row">
                                        <div class="col-2">
                                            <div class="field">
                                                <inline-edit-text label="Name" value="data.name"
                                                    save-func="C.inlineEditingSave(args)"
                                                    can-edit="C.hasPermission('org.change_org')">
                                                </inline-edit-text>
                                            </div>
                                        </div>
<!--                                    </div>-->
<!--                                    <div class="row">-->
                                        <div class="col-4">
                                            <div class="field">
                                                <inline-edit-text label="Description" value="data.description"
                                                    save-func="C.inlineEditingSave(args)"
                                                    can-edit="C.hasPermission('org.change_org')">
                                                </inline-edit-text>
                                            </div>
                                        </div>
<!--                                    </div>-->
<!--                                    <div class="row">-->
                                        <div class="col-2">
                                            <div class="field">
                                                <inline-edit-number label="Assigned Employees" value="C.benefitAssignmentsList[$index].assigned_employees.length"
                                                    can-edit="false">
                                                </inline-edit-number>
                                            </div>
                                        </div>
                                        <div class="col-1" style="margin-top: 1rem">
                                                <md-button ng-click="C.assignBenefits($index)" ng-if="C.hasPermission('org.change_org')"
                                                    class="md-icon-button md-primary">
                                                    <md-icon md-font-library="material-icons" class="p-0">assignment_ind</md-icon>
                                                    <md-tooltip md-direction="bottom">
                                                        Assign benefits to employees
                                                    </md-tooltip>

                                                </md-button>                                                
                                        </div>
                                    </div>
                                    <div class="divider"></div>
                                    <div>
                                    <label>Documents
                                        <div class="float-right p-r-30">
                                            <md-button ng-click="C.add_benefit_doc()" ng-if="C.hasPermission('org.change_org')"
                                                class="md-icon-button md-primary">
                                                <md-icon md-font-library="material-icons" class="p-0">add_circle</md-icon>
                                                <md-tooltip md-direction="bottom">Add Document</md-tooltip>
                                            </md-button>
                                        </div>
                                        <br>
                                        <div ng-repeat="document in data.documents track by $index" class="field">
                                            <div id="{{ariaId}}" class="card-header" data-toggle="collapse" data-target="#document{{$index}}_{{$parent.$index}}" aria-expanded="false" 
                                                aria-controls="#{{collapseId}}">
                                                <div class="row">
                                                    <div style="float: right; padding-right: 20px;">
                                                        <md-icon class="drop-arrow" style="margin: auto 0;" md-font-library="material-icons">keyboard_arrow_down</md-icon>
                                                    </div>
                                                    <div class="accordian-card-title">
                                                        {{document.title}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="document{{$index}}_{{$parent.$index}}" class="collapse">
                                                <br>
                                                <form ng-if="!C.editing" class="form-group">
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-md-2"></div>
                                                            <div class="col-md-8 col-sm-12">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="field">
                                                                            <inline-edit-text label="Title" value="document.title"
                                                                                save-func="C.inlineEditingSave(args)"
                                                                                can-edit="C.hasPermission('org.change_org')">
                                                                            </inline-edit-text>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="field">
                                                                            <inline-edit-text label="Description" value="document.description"
                                                                                save-func="C.inlineEditingSave(args)"
                                                                                can-edit="C.hasPermission('org.change_org')">
                                                                            </inline-edit-text>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="field">
                                                                            <inline-edit-file-upload label="File" file-name="C.fileName(document.file)"
                                                                                file-link="C.currentBenfitDoc.file" save-func="C.uploadILEFiles(args)"
                                                                                file-type="benefitDoc" delete-func="C.deleteBenefitDocUpload(arg)"
                                                                                can-edit="C.hasPermission('org.change_org')">
                                                                            </inline-edit-file-upload>
                                                                        </div>
                                                                        <md-button href="{{document.file}}" target="_blank"
                                                                            ng-click="C.emitEvent('org.benefits.doc.file_download')"
                                                                            class="d-inline-block md-icon-button md-primary m-0 flex-center">
                                                                        <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                                                                        </md-button>
                                                                        <a  ng-if="!C.editing_new &amp;&amp; C.hasPermission(&quot;org.change_org&quot;)"
                                                                            ng-click="C.deleteDocItem(document, &quot;benefit&quot;)" class="md-warn"><i
                                                                            class="material-icons">delete_forever</i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </label>
                                    </div>
                                </form>
                            </div>
                        </div>
                        </div>
                    </div>
    
        `;

    }

    public link($scope: any, $element: any, attrs: any): void {
        $scope.queryType = attrs.queryType;
    }

    
    public static DirectiveFn(): BenefitsTabDirective {
        return new BenefitsTabDirective();
    }

}

BenefitsTabDirective.DirectiveFn.$inject = [];

angular.module('beneple.global').directive('benefitsTab', BenefitsTabDirective.DirectiveFn);


// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/benefits_tab.directive.ts